// extracted by mini-css-extract-plugin
module.exports = {"container":"e_5x","question":"e_6x","button":"e_7x","buttonNegative":"e_8x","buttonPositive":"e_9x","icon":"e_-x","iconNegative":"e_ay","iconPositive":"e_by"};